import * as _ from 'lodash';

import React, {Component} from 'react';

import './FdlOutlinedInput.scss';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import {emailIsValid} from "../helpers";
import FormHelperText from "@material-ui/core/FormHelperText";
import {GUARDIAN, KEYHOLDER} from "../../config/constants";


class FdlOutlinedInput extends Component {

  constructor(props) {
    super(props);
    this.state = {errorText: this.props.errorText ? this.props.errorText : '' }
    this.checkValidInput = _.debounce(this.checkValidInput.bind(this), 500);
  }

  updateValue(value) {
    this.props.onChange(value);
    if (this.props.validators) {
      this.checkValidInput(value);
    }
  }

  checkValidInput(value) {
    let errorText = "";
    this.props.validators.forEach((validator) => {
      switch(validator) {
        case "email":
          if (!emailIsValid(value)) {
            errorText = "A valid email address is required."
          }
          break;
        case "required":
          if (value === null || value === "") {
            errorText = "This field is required."
          }
          break;
        case "unique":
          if (value && value !== _.get(this.props.options, 'cachedValue', "")) {
            if (value === this.props.options.ownerEmail) {
              errorText = "The Vault Owner can not act as a Keyholder or Guardian."
            }

            if (this.props.options.userType === KEYHOLDER) {
              if (_.includes(_.get(this.props.options, 'keyholders', []), value)) {
                errorText = "A keyholder with this email already exists."
              }

              if (_.includes(_.get(this.props.options, 'guardians', []), value)) {
                errorText = "A guardian with this email already exists. Users can not be a guardian and keyholder for the same vault."
              }

            } else if (this.props.options.userType === GUARDIAN){
              if (_.includes(_.get(this.props.options, 'keyholders', []), value)) {
                errorText = "A keyholder with this email already exists. Users can not be a guardian and keyholder for the same vault."
              }

              if (_.includes(_.get(this.props.options, 'guardians', []), value)) {
                errorText = "A guardian with this email already exists."
              }
            }
          }
      }
    });

    this.setState({
      errorText: errorText
    }, this.props.updateErrors && this.props.updateErrors(!!errorText))
  }

  render() {
    return (
      <div className={this.props.hideTopMargin ? '' : 'fdl-outlined-field-container'}>
        <FormControl style={{width: this.props.width ? this.props.width : "100%"}}
                     variant="outlined">
          {
            this.props.label &&
            <InputLabel className="form-label-override"
                        required={this.props.validators && _.includes(this.props.validators, 'required')}
                        shrink={true}>
              {this.props.label}
            </InputLabel>
          }
          <OutlinedInput
            required
            autoFocus={this.props.autoFocus}
            error={!!this.state.errorText}
            type={this.props.type ? this.props.type : "text"}
            value={this.props.value}
            multiline={!!this.props.rows}
            placeholder={this.props.placeholder ? this.props.placeholder : ""}
            rows={this.props.rows ? this.props.rows : null}
            onChange={({ target: { value } }) => this.updateValue(value)}
            margin="dense"
          />
          {this.state.errorText || this.props.errorText && <FormHelperText>{ this.state.errorText || this.props.errorText }</FormHelperText>}
        </FormControl>
      </div>
    );
  }
}

export default FdlOutlinedInput;
